import React from "react";
import "../styles/CardExperto.css";

export default function CardExperto({ name, experience, avatar }) {
  return (
    <div className="experto-card">
      <div className="avatar">
        <img src={avatar} alt={`${name} avatar`} />
      </div>
      <h3 className="experto-name">{name}</h3>
      <div className="experto-experience">{experience}</div>
    </div>
  );
}